export default "__VITE_ASSET__DyeMFYZ2__"